import React from 'react';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './explanation-template.styl';

function ExplanationTemplate({ selectedPart }) {
  const { t } = useTranslation()
  return (
    <div className="explanation-template">
      <h2>{t(`${selectedPart.title}`)}</h2>
      {selectedPart.description && <p>{t(`${selectedPart.description}`)}</p>}
      {selectedPart.subtitle && <p className="explanation-template__subtitle">{t(`${selectedPart.subtitle}`)}</p>}
      <div className="explanation-template__content">
        {selectedPart.subparts && selectedPart.subparts.map(subpart => (
          <div className="explanation-template__content-item">
            {subpart.icon && (
            <img
              src={subpart.icon}
              alt={subpart.title}
              className="explanation-template__content-item__icon"
            />
            )}
            <div className="explanation-template__content-item__text">
              <span>{t(`${subpart.title}`)}</span>
              {subpart.subtitle && <p>{t(`${subpart.subtitle}`)}</p>}
              {subpart.type === 'bullet' ? ( 
                <ul className="explanation-template__content-item__text__bullet">
                  {subpart.description.map(description => (
                    <li key={description}>{t(`${description}`)}</li>
                  ))}
                </ul>
              ) : (
                subpart.description && subpart.description.map(description => (
                  <p className={description.split(':')[0] === 'For example' ? 'explanation-template__content-item__text__example' : 'explanation-template__content-item__text__description'} key={description}>{t(`${description}`)}</p>
                ))
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ExplanationTemplate;